import type { RunBaseFormProps } from '@/pages/WorkflowsCatalog/components/run/run-base-form';
import RunBaseForm from '@/pages/WorkflowsCatalog/components/run/run-base-form';
import RunFormField from '@/pages/WorkflowsCatalog/components/run/run-form-field';

const RunInputForm = ({ form, workflow }: RunBaseFormProps) => {
  return (
    <RunBaseForm form={form} workflow={workflow}>
      {workflow.inputSchema?.properties &&
        Object.entries(workflow.inputSchema.properties).map(([key, property]: [string, any]) => (
          <RunFormField
            key={key}
            fieldName={`args.${key}` as any}
            property={property}
            workflow={workflow}
            form={form}
          />
        ))}
    </RunBaseForm>
  );
};

export default RunInputForm;
